import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { Container } from "@/components/CookiebotPage/styles";

const CookiebotPage: React.FC = () => {
  const divRef = useRef<HTMLDivElement>(null);
  const { locale = "it" } = useRouter();

  useEffect(() => {
    const CookieDeclarationScript = document.getElementById("CookieDeclaration");
    if (divRef.current && CookieDeclarationScript === null) {
      const script = document.createElement("script");
      script.id = "CookieDeclaration";
      script.src =
        "https://consent.cookiebot.com/99761933-b82a-4ddc-9501-e2cd54bd1f54/cd.js";
      script.async = true;
      script.setAttribute("data-culture", locale);
      divRef.current.appendChild(script);
    }
  }, [divRef]);

  return <Container ref={divRef}></Container>;
};

export default CookiebotPage;
